module.exports = __webpack_public_path__ + "static/media/jayla-lavender-nicholas.db8bc298.md";